import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type NotesDrawerResource = (
  | { type: `contact`; id: number }
  | { type: `invoice`; id: string }
  | { type: `escalation`; id: number }
) & {
  /** Required when opened outside the `:organisationId` route, e.g. from a multi-org report */
  organisationId?: string;
};

export const initialState: {
  resource: NotesDrawerResource | null;
  open: boolean;
} = {
  resource: null,
  open: false,
};

const notesDrawerSlice = createSlice({
  name: `notesDrawer`,
  initialState,
  reducers: {
    closeAndClear(state) {
      state.open = false;
      state.resource = null;
    },
    open(state, action: PayloadAction<NotesDrawerResource>) {
      state.open = true;
      state.resource = action.payload;
    },
  },
});

export const { closeAndClear, open } = notesDrawerSlice.actions;

export const notesDrawerReducer = notesDrawerSlice.reducer;
